module.exports = __webpack_public_path__ + "src/assets/games/7/fengchepic.png";